export default "__VITE_ASSET__DlTvRuid__"